import React from 'react'
import styled from 'styled-components'
import { stripUnit } from 'polished'

import { cover } from 'styles/global'
import { Lead, fontWeights, fontSizes } from 'styles/typography'
import { white } from 'styles/colors'
import { media, mediaDown } from 'styles/media'
import * as spacing from 'styles/spacing'

import Wrapper from 'components/Wrapper'
import Section from 'components/Section'
import Heading from 'components/buy/epod2/Heading'

const Container = styled.div`
  position: relative;
`

const Content = styled.div`
  position: relative;
  z-index: 1;
`

const Inner = styled.div`
  position: relative;

  ${media.medium`
    display: flex;
    align-items: center;
  `};
`

const FigureWrap = styled.div`
  position: relative;
  width: 180px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${spacing.large};

  ${media.small`
    width: 210px;
  `};

  ${media.medium`
    width: 280px;
    margin-bottom: 0;
  `};

  ${media.large`
    width: 320px;
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 167.7%;
  }
`

const Figure = styled.img`
  display: block;
  ${cover('absolute')};
`

const Main = styled.main`
  position: static;

  ${media.medium`
    width: 50%;
    margin-left: auto;
    padding: 0 5%;
  `};
`

const StyledHeading = styled(Heading)`
  position: static;
  margin-bottom: ${spacing.large};

  ${mediaDown.medium`
    text-align: center;
  `};

  ${media.medium`
    margin-bottom: ${spacing.xLarge};
  `};
`

const Details = styled.div`
  color: ${white};
  display: grid;
  grid-gap: ${spacing.large};
  font-size: ${fontSizes.small};

  p {
    font-size: ${fontSizes.tiny};

    ${media.medium`
      font-size: ${fontSizes.small};
    `};
  }

  ${mediaDown.medium`
    text-align: center;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.medium`
    grid-gap: ${spacing.xLarge};
  `};

  ${media.large`
    grid-gap: ${spacing.xxLarge};
  `};
`

const Subheading = styled(Lead)`
  display: block;
  font-weight: ${fontWeights.medium};
  color: ${white};
  text-transform: uppercase;
  margin-bottom: ${spacing.small};

  ${media.medium`
    margin-bottom: ${stripUnit(spacing.small) * 1.5 + 'px'};
  `};

  ${media.large`
    margin-bottom: ${spacing.medium};
  `};
`

const Background = styled.div`
  background: linear-gradient(180deg, #765750 0%, #ae847c 50%, #c39b94 50%, #af847c 100%);
  ${cover('absolute')};

  ${media.small`
    background: linear-gradient(180deg, #765750 0%, #ae847c 53.3%, #c39b94 53.3%, #af847c 100%);
  `};

  ${media.medium`
    background: linear-gradient(90deg, #765750 0%, #ae847c 50%, #c39b94 50%, #af847c 100%);
  `};
`

const Glow = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 56px;

  ${media.large`
    width: 66px;
  `};
`

const Logo = styled.img`
  display: inline-block;
  position: relative;
  top: -1px; /* Align with text */
  vertical-align: middle;
  width: 70px;

  ${media.medium`
    width: 80px;
  `};
`

const Why = () => (
  <Container id="why">
    <Content>
      <Section>
        <Wrapper>
          <Inner>
            <FigureWrap>
              <Figure src={`${process.env.BASE_PATH}/images/epod2/devices.png`} />
            </FigureWrap>
            <Main>
              <StyledHeading as="h2">
                WHY CHOOSE
                <br />
                <em data-text="VUSE ePod 2">VUSE ePod 2</em>
              </StyledHeading>
              <Details>
                <div>
                  <Subheading as="div">SLEEK NEW DESIGN</Subheading>
                  <p>
                    Redesigned with a modern angular shape, soft touch finish, and available in 5 premium metallic
                    colours.
                  </p>
                </div>
                <div>
                  <Subheading as="div">FAST CHARGE</Subheading>
                  <p>Charges up to 80% in 35 minutes.</p>
                </div>
                <div>
                  <Subheading as="div">SPLASH PROOF</Subheading>
                  <p>Dripping with features, it’s tested to IPX4 standard, meaning its splash proof.</p>
                </div>
                <div>
                  <Subheading as="div">
                    PERSONALIZE IT WITH&nbsp;
                    <Logo src={`${process.env.BASE_PATH}/images/menu/vuse-x-you-white.png`} />
                  </Subheading>
                  <p>Skins, rings and laser engravings – it’s the ultimate way to customize your device.</p>
                </div>
              </Details>
            </Main>
            <Glow src={`${process.env.BASE_PATH}/images/epod2/glow.png`} className="u-hide-medium-down" />
          </Inner>
        </Wrapper>
      </Section>
    </Content>
    <Background />
  </Container>
)

export default Why
